import { RootState } from 'redux/reducers';
import { AuthState } from './handlers';

export const authSelector = (state: RootState): AuthState => state.auth;
